import Login from "./Login/login";
import ForgotPassword from "./Forgotpassword/forgotpassword";
import ChangePassword from "./Changepassword/changepassword";

export const Auth = {
  Login,
  ForgotPassword,
  ChangePassword,
};
